import { useHookstate } from "@hookstate/core";
import InputField from "../input-field/InputField";
import {
  onInputChangeNative,
  showSnackbar,
  updateMiscState,
} from "../../misc/utils";
import DatePicker from "react-datepicker";
import { CustomDateInput } from "../CustomDateInput";
import { timeSlots } from "../../misc/constants";
import DefaultButton from "../default-button/DefaultButton";
import ArrowLeft from "../../assets/icons/ArrowLeft";
import Tick from "../../assets/icons/Tick";
import { simpleGetter } from "../../actions/common";
import { demeritsApi } from "../../api/api";
import { useGlobalMiscState } from "../../stores/misc";

export const DisciplinaryHearingCreate = () => {
  const miscState = useGlobalMiscState();
  const disciplinaryCasesSelectedForHearings =
    miscState.get("disciplinaryCasesSelectedForHearings") || [];
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const name = state.name || "";
  const startDate = state.startDate || "";
  const startTime = state.startTime || "";
  const endTime = state.endTime || "";

  const onDateChange = (date: Date | null) => {
    localState.merge({
      startDate: date,
    });
  };

  const toggleModal = () => {
    updateMiscState("disciplinaryHearingCreateModalOpen")(false);
  };

  const submit = async () => {
    const body = {
      name,
      start_date: startDate,
      start_time: startTime + ":00",
      end_time: endTime + ":00",
      cases: disciplinaryCasesSelectedForHearings,
    };
    const response = await simpleGetter(
      demeritsApi.createDisciplinaryHearing,
      body,
    );
    showSnackbar(
      response.success ? "Успешно" : "Произошла ошибка",
      response.success ? "success" : "error",
    );
    if (response.success) {
      miscState.setBatch({
        disciplinaryCasesSelectedForHearings: [],
        disciplinaryHearingsTriggerFetch:
          (miscState.get("disciplinaryHearingsTriggerFetch") || 0) + 1,
      });
      toggleModal();
    }
  };

  const validateForm = () => {
    return (
      name &&
      startDate &&
      startTime &&
      endTime &&
      timeSlots.indexOf(endTime) > timeSlots.indexOf(startTime)
    );
  };

  return (
    <div className='flex flex-col gap-8'>
      <span className='text-2xl leading-[26.4px] text-valley-black'>
        Назначение заседания
      </span>
      <InputField
        type='text'
        id='category-name'
        label='Название заседания'
        handleChange={onInputChangeNative(localState, "name")}
        value={name}
        additionalClassName='bg-valley-background-blue py-3 px-4 rounded-lg'
      />
      <div className='flex flex-row gap-3'>
        <div className='flex flex-col flex-1 gap-2'>
          <p className='text-[#5F6B88] font-medium text-sm'>Дата</p>
          <DatePicker
            selected={startDate}
            onChange={onDateChange}
            customInput={<CustomDateInput hasTime={false} />}
            dateFormat='dd/MM/yyyy'
            minDate={new Date()}
          />
        </div>
        <div className='flex flex-col flex-1 gap-2'>
          <InputField
            wrapperClassName='flex flex-col gap-2'
            additionalClassName='px-3 py-[10.5px] bg-valley-background-blue'
            type='select'
            id={"start-time"}
            label='Начало'
            value={startTime}
            handleChange={onInputChangeNative(localState, "startTime")}
            options={timeSlots.map((t) => ({ label: t, value: t }))}
          />
        </div>
        <div className='flex flex-col flex-1 gap-2'>
          <InputField
            wrapperClassName='flex flex-col gap-2'
            additionalClassName='px-3 py-[10.5px] bg-valley-background-blue'
            type='select'
            id={"end-time"}
            label='Конец'
            value={endTime}
            handleChange={onInputChangeNative(localState, "endTime")}
            options={timeSlots.map((t) => ({ label: t, value: t }))}
          />
        </div>
      </div>
      <div className='flex-1 flex flex-row gap-3'>
        <DefaultButton
          buttonText='Вернуться'
          additionalStyle='flex-1 bg-[#5F6B88] text-white px-8 py-3 text-nowrap'
          Icon={ArrowLeft}
          onClick={toggleModal}
        />
        <DefaultButton
          buttonText='Сохранить'
          additionalStyle='flex-1 bg-valley-main text-white px-8 py-3 text-nowrap'
          Icon={Tick}
          onClick={submit}
          disabled={!validateForm()}
        />
      </div>
    </div>
  );
};
